jQuery.prototype.mousedragscrollable = function () {
  let target;
  $illJq(this).each(function (i, e) {
    $illJq(e).mousedown(function (event) {
      event.preventDefault();
      target = $illJq(e);
      $illJq(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $illJq(e).scrollLeft(),
        scrolltop: $illJq(e).scrollTop(),
      });
      return false;
    });
    $illJq(e).click(function (event) {
      if ($illJq(e).data("move")) {
        return false;
      }
    });
  });
  $illJq(document)
    .mousemove(function (event) {
      if ($illJq(target).data("down")) {
        event.preventDefault();
        let move_x = $illJq(target).data("x") - event.clientX;
        let move_y = $illJq(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $illJq(target).data("move", true);
        } else {
          return;
        }
        $illJq(target).scrollLeft($illJq(target).data("scrollleft") + move_x);
        $illJq(target).scrollTop($illJq(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $illJq(target).data("down", false);
      return false;
    });
};


$illJq(".thumbnail_scroll").mousedragscrollable();